import { toLower } from "lodash-es";
import type { Directive } from "vue";

import { useSearchStore } from "@/stores";

const source = "source";
const target = "target";

const getLang = (arg: string, sourceLanguage?: string, targetLanguage?: string) => {
  if (arg === source) {
    return sourceLanguage;
  }

  if (arg === target) {
    return targetLanguage;
  }

  return arg;
};

const lang: Directive<HTMLElement> = {
  beforeMount: (el, binding) => {
    const arg = toLower(binding.arg) || target;
    const searchStore = useSearchStore();

    const attributeValue = getLang(
      arg,
      searchStore.searchSourceLanguage,
      searchStore.searchTargetLanguage
    );

    if (!attributeValue) {
      return;
    }

    el.setAttribute("lang", attributeValue);
  }
};

export default lang;
